"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
class CaseIdPathRequest extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsDefined)(),
    (0, apigw_models_1.Docs)({ example: '1234', description: 'BPM id of the case' }),
    tslib_1.__metadata("design:type", String)
], CaseIdPathRequest.prototype, "caseId", void 0);
exports.default = CaseIdPathRequest;
